import type { FaireProductEntity } from "../../entity_types/product";

export const p_nz7euf94ma: FaireProductEntity = {
  token: "p_nz7euf94ma",
  type: "product",
  name: "Hydroponic Skateboarding Griptape",
  brandToken: "b_9grp69f3nm",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/22d21f24c17596e94e8ff85aecbadb2b76ee596be2d8e01a313b95506d3690df.jpeg",
  galleryImageUrls: [],
  priceDollars: 55.87,
  description:
    "Hydroponic Skateboarding Griptape\n\n35' X 9'\n\nGreat grip to keep your feet on the board, featuring the Hydroponic logo and letters.",
  tags: [],
  msrpDollars: 111.73,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:11.614Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
